import { render, staticRenderFns } from "./task-to-sign.vue?vue&type=template&id=5a6b159c&scoped=true&"
import script from "./task-to-sign.vue?vue&type=script&lang=js&"
export * from "./task-to-sign.vue?vue&type=script&lang=js&"
import style0 from "./task-to-sign.vue?vue&type=style&index=0&id=5a6b159c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b159c",
  null
  
)

export default component.exports